<template>
  <div class="api-roles-picker">
    <v-row class>
      <v-col cols="12" md="6">
        <v-card class="ma-2 pa-2">
          <h1 class="display-1 mt-4">Current Roles</h1>
          <v-text-field
            v-model="currentSearch"
            clearable
            flat
            class="mx-2 my-4"
            prepend-inner-icon="search"
            label="Search"
          ></v-text-field>
          <v-list
            two-line
            v-if="filteredCurrentRoles.length > 0"
            max-height="500px"
            class="overflow-y-auto"
            dense
          >
            <template v-for="(role, index) in filteredCurrentRoles">
              <v-list-item :key="role.uuid" dense>
                <v-list-item-content>
                  <v-list-item-title v-text="role.name"></v-list-item-title>
                  <v-list-item-subtitle v-text="role.description"></v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="my-0">
                  <v-btn
                    color="error"
                    class="text-right"
                    small
                    @click="$emit('removeCurrent', role.uuid, role.name)"
                  >Remove</v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-divider v-if="index + 1 < filteredCurrentRoles.length" :key="index"></v-divider>
            </template>
          </v-list>
          <div v-else>
            <v-row justify="center" align="center" style="height:300px">
              <v-icon size="64" class="my-5" left>sentiment_dissatisfied</v-icon>
              <span class="title">No content</span>
            </v-row>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card class="ma-2 pa-2">
          <h1 class="display-1 mt-4">Available Roles</h1>
          <v-text-field
            v-model="availableSearch"
            clearable
            flat
            class="mx-2 my-4"
            prepend-inner-icon="search"
            label="Search"
          ></v-text-field>
          <v-list
            two-line
            v-if="filteredAvailableRoles.length > 0"
            max-height="500px"
            class="overflow-y-auto"
            dense
          >
            <template v-for="(role, index) in filteredAvailableRoles">
              <v-list-item :key="role.uuid" dense>
                <v-list-item-content>
                  <v-list-item-title v-text="role.name"></v-list-item-title>
                  <v-list-item-subtitle v-text="role.description"></v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="my-0">
                  <v-btn
                    color="success"
                    class="text-right"
                    small
                    @click="$emit('addAvailable', role.uuid, role.name)"
                  >Add</v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-divider v-if="index + 1 < filteredAvailableRoles.length" :key="index"></v-divider>
            </template>
          </v-list>
          <div v-else>
            <v-row justify="center" align="center" style="height:300px">
              <v-icon size="64" class="my-5" left>sentiment_dissatisfied</v-icon>
              <span class="title">No content</span>
            </v-row>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    availableRoles: { type: Array, required: true },
    currentRoles: { type: Array, required: true }
  },
  data() {
    return {
      availableSearch: "",
      currentSearch: ""
    };
  },
  computed: {
    filteredCurrentRoles() {
      return this.currentRoles.filter(role =>
        role.name.toLowerCase().includes(this.currentSearch.toLowerCase())
      );
    },
    filteredAvailableRoles() {
      return this.availableRoles.filter(role =>
        role.name.toLowerCase().includes(this.availableSearch.toLowerCase())
      );
    }
  }
};
</script>

<style>
</style>